module.exports = __webpack_public_path__ + "static/recent-a62c0d7a9d3e16c9bceb10d160ec5984.png";